import { render, staticRenderFns } from "./trend-up.vue?vue&type=template&id=3135a97f&scoped=true&"
import script from "./trend-up.vue?vue&type=script&lang=js&"
export * from "./trend-up.vue?vue&type=script&lang=js&"
import style0 from "./trend-up.vue?vue&type=style&index=0&id=3135a97f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3135a97f",
  null
  
)

export default component.exports